// WCA 风格的打乱公式生成器（随机转动序列，避免明显还原段）
// 说明：csTimer 使用 random-state 生成，这里采用常见的高质量随机序列算法，
// 足以满足日常训练需求；如需 random-state 可后续替换为 cubing.js 等库。

const FACES3 = ['U', 'D', 'L', 'R', 'F', 'B'];
const FACES2 = ['U', 'R', 'F']; // 2x2 通常只用 U R F（保持可打乱性）
const FACES4 = ['U', 'D', 'L', 'R', 'F', 'B', 'Uw', 'Dw', 'Lw', 'Rw', 'Fw', 'Bw'];
const FACES_PYRA = ['U', 'L', 'R', 'B'];
const TIPS_PYRA = ['u', 'l', 'r', 'b'];
const FACES_SKEWB = ['U', 'L', 'R', 'B'];

function axisOf(move) {
  const f = move[0].toLowerCase();
  if (f === 'u' || f === 'd') return 0;
  if (f === 'l' || f === 'r') return 1;
  return 2;
}

function opposite(face) {
  return { U: 'D', D: 'U', L: 'R', R: 'L', F: 'B', B: 'F' }[face] || null;
}

function turnSuffix() {
  const r = Math.random();
  if (r < 1 / 3) return '';
  if (r < 2 / 3) return "'";
  return '2';
}

// 生成一段符合约束的序列：不同时出现同一面、同一轴最多连续两次、
// 避免 "R L R" 这类相邻两次反向抵消的情况
function generate(faces, length) {
  const seq = [];
  let lastFace = '';
  let lastAxis = -1;
  let prevAxis = -1;

  while (seq.length < length) {
    const face = faces[Math.floor(Math.random() * faces.length)];
    const axis = axisOf(face);
    if (face === lastFace) continue;
    if (axis === lastAxis && axis === prevAxis) continue;
    // 防止 R L R 模式（同轴反向回跳）
    if (seq.length >= 2 && face === opposite(seq[seq.length - 2][0]) && axis === lastAxis) continue;
    seq.push(face + turnSuffix());
    prevAxis = lastAxis;
    lastAxis = axis;
    lastFace = face;
  }
  return seq.join(' ');
}

export function scrambleFor(kind) {
  switch (kind) {
    case 'cube2':
      return generate(FACES2, 11);
    case 'cube4':
      return generate(FACES4, 40);
    case 'pyraminx': {
      const body = generate(FACES_PYRA, 11);
      // 金字塔附带随机 tip 转动
      const tips = TIPS_PYRA.filter(() => Math.random() < 0.7).map((t) => t + turnSuffix());
      return [...tips, body].join(' ');
    }
    case 'skewb':
      return generate(FACES_SKEWB, 11);
    case 'cube3':
    default:
      return generate(FACES3, 20);
  }
}

export function nextScramble(eventKey) {
  const map = {
    '3x3': 'cube3',
    '2x2': 'cube2',
    '4x4': 'cube4',
    '3bld': 'cube3',
    oh: 'cube3',
    pyraminx: 'pyraminx',
    skewb: 'skewb',
  };
  return scrambleFor(map[eventKey] || 'cube3');
}
